// Core 页面内容
import { APP_INFO, OLD_VERSIONS } from '../app-info';

export const corePages = {
  'latest-version': {
    h1: 'GB WhatsApp Latest Version Download',
    subtitle: 'Get the newest GB WhatsApp APK for Android — updated regularly with privacy tools, performance fixes, and anti-ban improvements.',
    badge: `${APP_INFO.version} · Updated ${APP_INFO.updateMonth}`,
    toc: [
      { id: 'app-info', label: 'App Info' },
      { id: 'download', label: 'Download' },
      { id: 'faq', label: 'FAQ' },
    ],
    sections: [
      {
        id: 'app-info',
        h2: 'Key App Information',
        infoTable: [
          { label: 'Latest Version', value: APP_INFO.version },
          { label: 'APK Size', value: APP_INFO.apkSize },
          { label: 'Android Requirement', value: APP_INFO.androidReq },
          { label: 'Category', value: 'Communication / Messaging' },
          { label: 'Last Updated', value: APP_INFO.updateMonth },
          { label: 'Price', value: 'Free' },
        ],
        paragraphs: [
          'The file you download is an APK, not a Play Store app, which means you install it manually on your Android phone after enabling installs from unknown sources. Make sure you have at least 200 MB of free storage before starting — that covers the APK itself plus the space needed during installation.',
          'GB WhatsApp mods are updated frequently, and this build includes the latest anti-ban patch and UI fixes from early 2026. If you already use GB WhatsApp, you can install this APK directly over your current version without losing chats or settings, as long as both files come from the same trusted source.',
        ],
      },
      {
        id: 'download',
        h2: 'How to Download the Latest GB WhatsApp APK',
        steps: [
          'Tap the download button at the top of this page.',
          'Wait for the APK file to finish downloading (about 60 MB).',
          'Open your phone Settings and allow installs from your browser.',
          'Tap the downloaded file and follow the on-screen steps.',
          'Verify your phone number and restore chats if needed.',
        ],
      },
      {
        id: 'faq',
        h2: 'Frequently Asked Questions',
        faqs: [
          {
            question: 'Is the latest GB WhatsApp free?',
            answer: 'Yes — GB WhatsApp is completely free to download and use. We do not charge for the APK file on this site, and there are no subscriptions or in-app purchases involved.',
          },
          {
            question: 'Do I need to uninstall the old version first?',
            answer: 'Usually not. Installing the new APK over your existing version keeps your chats and settings intact. If the install fails with a signature error, check our update guide or the not-installing troubleshooting page for the right fix.',
          },
          {
            question: 'Is this the official WhatsApp app?',
            answer: 'No. GB WhatsApp is a third-party mod developed independently from Meta and WhatsApp Inc. It offers extra features but is not officially supported or verified by either company.',
          },
          {
            question: 'Can I use this on iPhone?',
            answer: 'No — this APK is built for Android only. iOS does not allow this type of mod installation without jailbreaking, which most users should avoid.',
          },
          {
            question: 'What Android version do I need?',
            answer: 'You need Android 5.0 (Lollipop) or higher, which covers most phones released from 2016 onward. Very old devices may run the latest build more slowly, in which case our old versions page lists previous APKs that work better on older hardware.',
          },
        ],
      },
    ],
  },

  update: {
    h1: 'GB WhatsApp Update – How to Get the Latest Version',
    subtitle: 'A step-by-step guide to updating GB WhatsApp without losing your chats, settings, or custom themes.',
    badge: 'Update Guide',
    sections: [
      {
        h2: 'Why Update GB WhatsApp?',
        paragraphs: [
          'Keeping GB WhatsApp up to date matters more than most users realize. New builds fix bugs, improve performance, and add privacy features that older versions simply do not have — and running an outdated APK can lead to login errors, missing tools, or increased ban risk over time.',
          'Unlike the official app, GB WhatsApp does not update through the Play Store. You need to download and install the new APK manually, but the process takes under five minutes if you follow the steps below and avoid uninstalling first.',
        ],
      },
      {
        h2: 'Before You Update',
        list: [
          'Back up your chats: GB WhatsApp → Settings → Chats → Back up chats',
          'Note your current version in Settings → Help',
          'Make sure you have enough storage (at least 200 MB free)',
          'Connect to stable Wi-Fi for the download',
          'Close GB WhatsApp before starting the APK install',
        ],
        paragraphs: [
          'A backup protects your messages if something goes wrong during the update — Google Drive backup is the safest option for most users. Charge your phone to at least 50% before starting, because a sudden shutdown mid-install can corrupt the app. Also disable battery saver mode during the download, since some phones pause background downloads to conserve power.',
        ],
      },
      {
        h2: 'How to Update GB WhatsApp (Step by Step)',
        steps: [
          'Download the latest APK from our <a href="/gb-whatsapp-latest-version/"><strong>GB WhatsApp latest version page</strong></a>.',
          'Do NOT uninstall your current GB WhatsApp — this would delete chats stored locally on your phone.',
          'Open the new APK file from your Downloads folder.',
          'Tap Install. The new version installs over the old one.',
          'Open GB WhatsApp and check that your chats are still there.',
          'If prompted, restore any pending backup from Google Drive.',
        ],
      },
      {
        h2: 'Update Failed? Try These Fixes',
        paragraphs: [
          'If the install button is greyed out, you likely have a signature mismatch — this happens when your current GB WhatsApp came from a different source than the new APK. In that case, back up your chats, uninstall the old app, and do a fresh install using our <a href="/gb-whatsapp-install/"><strong>install guide</strong></a>.',
          'Low storage and corrupted downloads are the other common causes. Free up space, delete the partial APK, and download again from a trusted source. Never uninstall first unless you have a confirmed backup ready, and if you need a previous build, our old versions page lists stable APK files for downgrade scenarios.',
        ],
      },
      {
        h2: 'After a Successful Update',
        paragraphs: [
          'Once the install finishes, open GB WhatsApp and check Settings → Help to confirm the new version number matches what you downloaded. Send a test message to a friend to verify that delivery and read receipts work normally, and re-enable any custom privacy settings — some toggles reset after major updates.',
          'If your chats look intact and messaging works as expected, you are done until the next release. We update our download page whenever a new version becomes available, so bookmark it for future updates.',
        ],
      },
      {
        h2: 'Frequently Asked Questions',
        faqs: [
          {
            question: 'Will I lose my chats when I update?',
            answer: 'No, as long as you install over the existing app without uninstalling first. Your chats stay on your phone through the update process. Backing up before you start is still a smart precaution in case anything unexpected happens.',
          },
          {
            question: 'How often should I update?',
            answer: 'Check for updates every few weeks, or whenever you notice bugs or connection issues. We update our download page as soon as a new stable build is available, so you do not need to hunt for APK files elsewhere.',
          },
          {
            question: 'Can I go back to an older version?',
            answer: 'Yes — visit our old versions page to find previous APK files. You may need to uninstall the current version first, which is why backing up your chats beforehand is essential.',
          },
          {
            question: 'Does updating fix ban issues?',
            answer: 'Updating to the latest build may help if you were banned for using an outdated mod version, since newer releases include anti-ban improvements. It does not guarantee ban removal, but running the newest APK is always safer than staying on an old one.',
          },
        ],
      },
    ],
  },

  install: {
    h1: 'How to Install GB WhatsApp on Android',
    subtitle: 'A clear, beginner-friendly install guide that takes about five minutes from download to your first message.',
    badge: 'Install Guide',
    sections: [
      {
        h2: 'What You Need Before Installing',
        list: [
          'An Android phone running version 5.0 or higher',
          'At least 200 MB of free storage',
          'A stable internet connection',
          'Your phone number for verification',
          'Permission to install apps from outside the Play Store',
        ],
        paragraphs: [
          'GB WhatsApp is not available on Google Play, so you download the APK file directly and install it manually on your phone. If you currently use official WhatsApp, back up your chats before switching — the backup stays in Google Drive and can be restored during GB WhatsApp setup.',
          'The install process takes about five minutes on most phones. You will need your SIM active to receive the OTP verification code, and you should use the same phone number you want on GB WhatsApp, since one number cannot run on two WhatsApp clients at the same time.',
        ],
      },
      {
        h2: 'Step-by-Step Install Guide',
        steps: [
          'Download the APK from our <a href="/gb-whatsapp-latest-version/"><strong>latest version download page</strong></a>.',
          'Go to Settings → Security → Install unknown apps → enable for your browser.',
          'Open the downloaded APK file from your notification or Downloads folder.',
          'Tap Install and wait for it to finish.',
          'Open GB WhatsApp, enter your phone number, and verify with the OTP code.',
          'Restore your chat backup if you are switching from official WhatsApp.',
        ],
      },
      {
        h2: 'Switching from Official WhatsApp',
        paragraphs: [
          'Start by backing up chats in official WhatsApp: Settings → Chats → Chat backup → Back Up. Then uninstall official WhatsApp — your backup stays safely in Google Drive tied to your Google account, so you can restore it during GB WhatsApp setup.',
          'After installing GB WhatsApp and verifying your number, tap Restore when prompted. Large backups can take 10–30 minutes on slow connections, so keep your phone plugged in and do not close the app until the progress bar completes. If restore fails, check that you are signed into the same Google account you used for the original backup.',
        ],
      },
      {
        h2: 'First-Time Tips',
        list: [
          'Explore Settings → Privacy to set up hide online and anti-delete',
          'Try dual accounts if you manage two phone numbers',
          'Browse themes under Settings → Universal → Styles',
          'Enable daily chat backup for peace of mind',
        ],
        paragraphs: [
          'Take a few minutes to configure privacy settings before you start chatting — the defaults are similar to official WhatsApp, but GB WhatsApp offers many more options that are worth exploring early on.',
        ],
      },
      {
        h2: 'Install Not Working?',
        paragraphs: [
          'Install failures usually come down to a few common causes: blocked unknown sources, insufficient storage, a corrupted download, or a signature mismatch between different mod sources. Our <a href="/gb-whatsapp-not-installing/"><strong>GB WhatsApp not installing</strong></a> page covers every fix step by step, so you can work through them in order without guessing.',
          'If you see a signature error specifically, you may need to uninstall any other WhatsApp mod first before installing GB WhatsApp fresh. Always back up before uninstalling to avoid losing locally stored chats.',
        ],
      },
      {
        h2: 'Frequently Asked Questions',
        faqs: [
          {
            question: 'Can I use GB WhatsApp and official WhatsApp together?',
            answer: 'Not with the same phone number on one device, since both apps compete for the same package slot. You can, however, use dual account support to run two different numbers on one phone, or use each app on separate devices.',
          },
          {
            question: 'Do I need to root my phone?',
            answer: 'No — GB WhatsApp works on normal, non-rooted Android phones without any special modifications. Rooting is not required and is not recommended for most users.',
          },
          {
            question: 'Is installation safe?',
            answer: 'Installation is safe when you download from a trusted source and understand the risks of using a mod app. See our safety pages for a balanced look at what to expect before you install.',
          },
          {
            question: 'Why is my OTP not arriving?',
            answer: 'OTP delays are usually caused by weak signal, SMS filtering, or requesting too many codes in a row. Check your signal strength, wait at least 60 seconds, and tap Call Me if SMS is delayed. Our OTP troubleshooting page has more detailed fixes.',
          },
        ],
      },
    ],
  },

  'old-versions': {
    h1: 'GB WhatsApp Old Versions Download',
    subtitle: 'Download previous GB WhatsApp APK files when the latest version causes issues on your device or fails to install.',
    badge: 'Archive',
    sections: [
      {
        h2: 'Why Download an Older Version?',
        paragraphs: [
          'Sometimes the newest GB WhatsApp update introduces bugs on certain phone models, and an older, stable build may run more smoothly on your hardware. You might also need a previous version if the latest APK fails to install due to signature changes between different download sources.',
          'Downgrading should be a last resort, though — older builds miss recent anti-ban patches and security fixes that newer releases include. Always back up your chats before switching versions, because uninstalling without a backup permanently removes locally stored messages.',
        ],
      },
      {
        h2: 'Available Old Versions',
        versionDownloads: OLD_VERSIONS,
        paragraphs: [
          'Each version below has its own download button, so you can grab the specific build you need without being redirected to the latest page. We recommend trying v18.80 first if your device supports it, since older builds may lack recent anti-ban and security improvements.',
          'Stick to one trusted download source for all versions — mixing APKs from random forums is a common cause of install failures and potential security risks. If you need the newest build instead, visit our <a href="/gb-whatsapp-latest-version/"><strong>GB WhatsApp latest version page</strong></a>.',
        ],
      },
      {
        h2: 'How to Install an Old Version',
        steps: [
          'Back up your current chats first.',
          'Uninstall the current GB WhatsApp (chats on phone will be removed — backup is essential).',
          'Download the old APK version you need from the links above.',
          'Install the APK and verify your phone number.',
          'Restore your chat backup from Google Drive or local storage.',
        ],
        paragraphs: [
          'If you need help with unknown sources or OTP verification during setup, follow our <a href="/gb-whatsapp-install/"><strong>GB WhatsApp install guide</strong></a>. After downgrading, check Settings → Help to confirm the version number matches what you intended to install.',
        ],
      },
      {
        h2: 'When to Avoid Old Versions',
        paragraphs: [
          'Skip older builds if your main concern is ban risk, since newer versions include better anti-ban protection that older APKs lack. Do not downgrade just for one missing feature without first checking whether the latest version already addressed your issue.',
          'If an old version works well on your device, still plan to move back to the latest build when your phone supports it — you will get better security, performance, and feature updates. Report broken download links via our contact page so we can refresh the archive.',
        ],
      },
      {
        h2: 'Frequently Asked Questions',
        faqs: [
          {
            question: 'Is it safe to use old versions?',
            answer: 'Older versions may miss important bug fixes and anti-ban updates, so use them only when the latest version genuinely does not work on your device. For most users, staying on the newest build is the safer long-term choice.',
          },
          {
            question: 'Can I update from an old version later?',
            answer: 'Yes — download the latest APK and install it over the old version without uninstalling. Your chats should remain intact as long as both files come from the same trusted source.',
          },
          {
            question: 'Why does the install fail with "App not installed"?',
            answer: 'This usually means a signature mismatch between versions from different sources. Uninstall the current app, then install the old APK fresh from a single trusted download site.',
          },
        ],
      },
    ],
  },
};
